import React from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import swal from "sweetalert";
import { getCookie } from "../../inc/cookies";
import config from "../../inc/config";
import { isoToDateTime } from "../../inc/helper";

import Select from 'react-select';
import AuctionCommentModal from "../../component/auctiom/AuctionCommentModal";

class AuctionItemAddModule extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,

      auctionVehicle: {},
      cities: [],
      towns: [],

      auctionId: 0,
      auctionVehicleId: 0,
      cityId: '',
      townId: '',
      initialPrice: '',
      thresholdPrice: '',
      vat: '',
      startDate: '',
      endDate: '',

      isSpecialTaxAssessment: 0,

      isOpenCommentModal: false,
      comment: '',
    };
  }

  componentDidMount() {
    this.getAuctionVehicle();
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {}

  getAuctionVehicle() {
    let sessionHash = getCookie('sessionHash');

    this.setState({isLoading: true});

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    let errorMessages = [];
    let remaining = 2;
    let complete = () => {
      remaining--;
      if (remaining === 0) {
        this.setState({isLoading: false});
        if (errorMessages.length > 0) {
          swal({dangerMode: true, icon: 'warning', title: 'Hay Aksi', text: errorMessages[0], buttons: 'Tamam'}).then(this.props.navigate('/home'));
        }else{
          this.setState({isLoading: false});
        }
      }
    }

    fetch(config.restApi + `auctionVehicle/tr/${this.props.searchParams.get('auctionVehicleId')}`, requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          this.setState({isLoading: false, auctionVehicle: responseData.auctionVehicleInfo});
        }
        break;
        case 401:  {
          errorMessages.push(responseData.message);
        }
        break;
        default: {
          errorMessages.push(responseData.message);
        }
        break;
      }
      complete();
    }, () => errorMessages.push('Lütfen internet bağlantınızı kontrol ediniz.'));

    fetch(config.restApi + 'cities/tr/1', requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          const sortedCities = responseData.cities.sort((first, last) => first.name.localeCompare(last.name));
          this.setState({cities: sortedCities, towns: []});
        }
        break;
        default: {
          errorMessages.push(responseData.message);
        }
        break;
      }
      complete();
    }, () => errorMessages.push('Lütfen internet bağlantınızı kontrol ediniz.'));
  }

  getTowns(cityId) {
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    fetch(config.restApi + 'towns/tr/' + cityId, requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          this.setState({cityId: cityId, townId: '', towns: responseData.towns});
        }
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(this.props.navigate('/home'))
        break;
        default: {
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  saveAuctionItemOnClick = () => {
    let sessionHash = getCookie('sessionHash');

    this.setState({isLoading: true});

    const startDateIso = new Date(this.state.startDate).toISOString();
    const endDateIso = new Date(this.state.endDate).toISOString();

    const requestOptions = {
      method: 'POST',
      headers: {'Authorization': 'Bearer ' + sessionHash, 'Content-Type': 'application/json'},
      body: JSON.stringify({auctionId: parseInt(this.props.searchParams.get('auctionId')), auctionVehicleId: parseInt(this.props.searchParams.get('auctionVehicleId')), cityId: this.state.cityId, townId: this.state.townId, initialPrice: this.state.initialPrice, thresholdPrice: this.state.thresholdPrice, vat: parseInt(this.state.vat), isSpecialTaxAssessment: parseInt(this.state.isSpecialTaxAssessment), startDate: startDateIso, endDate: endDateIso})
    };

    fetch(config.restApi + 'auctionItem/tr', requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          this.setState({isLoading: false});
          swal({
            dangerMode: true,
            icon: 'success',
            title: 'Tamamlandı',
            text: 'İhale başarıyla eklendi.',
            buttons: 'Tamam'
          }).then(() => this.props.navigate(`/auctionItemChoose?auctionId=${this.props.searchParams.get('auctionId')}`));
        }
        break;
        default: {
          this.setState({isLoading: false});

          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  selectedCityOnChange = (selectedCity) => {
    let cityId = selectedCity ? selectedCity.value : '';
    if (cityId) {
      this.getTowns(cityId);
    } else {
      this.setState({cityId: '', townId: '', towns: []});
    }
  }

  selectedTownOnChange = (selectedTown) => {
    this.setState({townId: selectedTown ? selectedTown.value : ''});
  }

  priceFormat = (value) => {
    if (!value) return '';
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  render() {

    const selectedCitiesOptions = [
      {value: '', label: 'Seçiniz' }, ...this.state.cities.map((cityInfo) => ({
        value: cityInfo.id,
        label: `${cityInfo.name}`,
        search: cityInfo.name
      }))
    ];

    const selectedTownsOptions = [
      { value: '', label: 'Seçiniz' }, ...this.state.towns.map((townInfo) => ({
        value: townInfo.id,
        label: `${townInfo.name}`,
        search: townInfo.name
      }))
    ];

    return this.state.isLoading ? (
      <div className="ibox-content sk-loading position-static">
        <div className="sk-spinner sk-spinner-fading-circle">
          <div className="sk-circle1 sk-circle"></div>
          <div className="sk-circle2 sk-circle"></div>
          <div className="sk-circle3 sk-circle"></div>
          <div className="sk-circle4 sk-circle"></div>
          <div className="sk-circle5 sk-circle"></div>
          <div className="sk-circle6 sk-circle"></div>
          <div className="sk-circle7 sk-circle"></div>
          <div className="sk-circle8 sk-circle"></div>
          <div className="sk-circle9 sk-circle"></div>
          <div className="sk-circle10 sk-circle"></div>
          <div className="sk-circle11 sk-circle"></div>
          <div className="sk-circle12 sk-circle"></div>
        </div>
      </div>
    ) : (
      <div className="row custom-container">
        <div className="col-12">
          <div className="ibox">
            <div className="ibox-title d-flex justify-content-between pr-3">
              <strong className="text-black">İhaleye Araç Ekle</strong>
              <div className="d-flex">
                <button className="btn bg-orange text-white mr-1" onClick={this.saveAuctionItemOnClick} title="Kaydet"><i className="fa fa-save"></i></button>
                <button className="btn btn-darkblue" onClick={() => this.props.navigate(-1)} title="geri"><i className="fa fa-reply"></i></button>
              </div>
            </div>
            <div className="table-responsive-lg mb-5">
              <table className="table table-bordered text-center">
                <thead>
                  <tr className="text-black">
                    <th>Araç Adı</th>
                    <th>Araç Markası</th>
                    <th>Açıklama</th>
                    <th>Eklenme Tarihi</th>
                    <th>Düzenlenme Tarihi</th>
                    <th>İptal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="align-middle">{this.state.auctionVehicle.title}<br />Araç No #:{this.state.auctionVehicle.id}</td>
                    <td className="align-middle">{this.state.auctionVehicle.vehicleBrandName} - {this.state.auctionVehicle.vehicleModelName} <br />{this.state.auctionVehicle.vehicleEquipmentName} - {this.state.auctionVehicle.year}</td>
                    <td className="align-middle"><button className="btn btn-orange" title="Açıklama" onClick={() => this.setState({comment: this.state.auctionVehicle.comment, isOpenCommentModal: true})}><i className="fa fa-eye"></i></button></td>
                    <td className="align-middle">{isoToDateTime(this.state.auctionVehicle.addedDate)}</td>
                    <td className="align-middle">{isoToDateTime(this.state.auctionVehicle.modifiedDate)}</td>
                    <td className="align-middle">
                      <Link className="btn btn-outline btn-orange text-white text-center mb-1" title="İptal Et" to={`/auctionItemChoose?auctionId=${this.props.searchParams.get('auctionId')}`}><i className="fa fa-trash"></i></Link>
                    </td>
                  </tr>
                  {this.state.auctionVehicle.length === 0 && <tr><td className="align-middle text-darkblue p-3" colSpan="6">Araç Bulunamadı !</td></tr>}
                </tbody>
              </table>
              <div className="row">
                <div className="col">
                  <div className="ibox">
                    <div className="ibox-content text-darkblue">
                      <div className="row">
                        <div className="col">
                        <div className="row">
                          <div className="col-md-6">
                            <h5><strong>Şehir<strong className="text-danger ml-1">*</strong></strong></h5>
                            <Select
                              className="form-input mb-2 mt-1 text-dark"
                              onChange={this.selectedCityOnChange}
                              options={selectedCitiesOptions}
                              isClearable={true}
                              defaultValue={selectedCitiesOptions[0]}
                              placeholder="Seçiniz"
                              value={selectedCitiesOptions.find((cityInfo) => cityInfo.value === this.state.filterCityId)}
                              filterOption={(option, searchText) => option.data.search && option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))}
                            />
                          </div>
                          <div className="col-md-6">
                            <h5><strong>İlçe<strong className="text-danger ml-1">*</strong></strong></h5>
                            <Select
                              className="form-input mb-2 mt-1 text-dark"
                              isDisabled={this.state.towns.length === 0}
                              onChange={this.selectedTownOnChange}
                              options={selectedTownsOptions}
                              isClearable={true}
                              defaultValue={selectedTownsOptions[0]}
                              placeholder="Seçiniz"
                              value={selectedTownsOptions.find((townInfo) => townInfo.value === this.state.filterTownId)}
                              filterOption={(option, searchText) => option.data.search && option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <h5><strong>Açılış Fiyatı<strong className="text-danger ml-1">*</strong></strong></h5>
                            <input className="form-control form-input mb-1" onChange={event => this.setState({initialPrice: event.target.value.replace(/[^0-9]/g, "")})} onKeyDown={this.handleKeyPress} placeholder="Açılış Fiyatı" type="text" value={this.priceFormat(this.state.initialPrice) || ''} />
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Eşik Fiyatı<strong className="text-danger ml-1">*</strong></strong></h5>
                            <input className="form-control form-input mb-1" onChange={event => this.setState({thresholdPrice: event.target.value.replace(/[^0-9]/g, "")})} onKeyDown={this.handleKeyPress} placeholder="Eşik Fiyatı" type="text" value={this.priceFormat(this.state.thresholdPrice) || ''} />
                          </div>
                          <div className="col-12">
                            <h5><strong>KDV Oranı<strong className="text-danger ml-1">*</strong></strong></h5>
                            <select className="form-control b-r-sm m-b mr-2" name="KDV Oranı" onChange={event => this.setState({vat: event.target.value})} value={this.state.vat}>
                              <option value="" disabled>KDV Oranı</option>
                                <option value={0}>%0</option>
                                <option value={1}>%1</option>
                                <option value={20}>%20</option>
                            </select>
                          </div>
                          <div className="col-12 mb-2">
                            <input checked={this.state.isSpecialTaxAssessment === 1} id="isSpecialTaxAssessment" onChange={event => this.setState({ isSpecialTaxAssessment: event.target.checked ? 1 : 0 })} type="checkbox" />
                            <label className="form-check-label pl-2" htmlFor="isSpecialTaxAssessment">Özel Matrahlı</label>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <h5><strong>Başlangıç Tarihi<strong className="text-danger ml-1">*</strong></strong></h5>
                            <input className="form-control form-inputt mb-2 mt-1" onChange={event => this.setState({startDate: event.target.value})} onKeyDown={this.handleKeyPress} type="datetime-local" value={this.state.startDate}/>
                          </div>
                          <div className="col-md-6">
                            <h5><strong>Bitiş Tarihi<strong className="text-danger ml-1">*</strong></strong></h5>
                            <input className="form-control form-inputt mb-2 mt-1" onChange={event => this.setState({endDate: event.target.value})} onKeyDown={this.handleKeyPress} type="datetime-local" value={this.state.endDate}/>
                          </div>
                        </div>
                        </div>
                      </div>
                      <div className="text-row text-right mt-2">
                        <button className="btn bg-orange text-white" onClick={this.saveAuctionItemOnClick}><i className="fa fa-save"></i> Kaydet</button>
                      </div>
                    </div>
                    <AuctionCommentModal comment={this.state.comment} isOpen={this.state.isOpenCommentModal} modalTitle="Araç Açıklaması" onRequestClose={() => this.setState({isOpenCommentModal: false})} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default function AuctionItemAdd(props) {
  return (
    <AuctionItemAddModule navigate={useNavigate()} searchParams={useSearchParams()[0]}></AuctionItemAddModule>
  );
}
